import { DatePicker, Input, InputNumber, message, Select, Switch } from 'antd';
import { updateTrain, createTrain } from '@/api';
import { FormModal, UploadImage } from '@/components';
import { ergodicObj, toDateTime } from '@/utils/utils';
import { st_banner } from '@/utils/statetype';
import React, { useState } from 'react';

const { positionObj, typeObj } = st_banner;
function BannderEdit({ visible, data, onChange }) {
  console.log("data", data)
  const [datas, setDatas] = useState({});
  // setDatas(data)
  const handleSubmit = async params => {
    console.log("params:", params)
    if (!params) return onChange();
    const { status, video, ...props } = params;

    data.id
      ? await updateTrain({
        body: {
          id: data.id,
          ...params,
          status: status ? 1 : 0,
          video: video || "",
        },
      })
      : await createTrain({
        body: {
          ...props,
          status: status ? 1 : 0,
          video: video || "",
        },
      });
    message.success('操作成功');
    onChange(true);
  };

  const formData = [
    data?.id && {
      name: 'id',
      label: '编号',
      rules: [{ required: false, message: '请输入编号' }],
      render: <InputNumber disabled placeholder="请输入编号" />,
    },
    {
      name: 'trainCategoryId',
      label: '分类编号',
      rules: [{ required: true, message: '请输入分类编号' }],
      render: <InputNumber placeholder="请输入分类编号" />,
    },
    {
      name: 'title',
      label: '标题',
      rules: [{ required: true, message: '请输入标题' }],
      render: <Input placeholder="请输入标题" />,
    },
    {
      name: 'content',
      label: '内容',
      rules: [{ required: false, message: '请输入内容' }],
      render: <Input.TextArea placeholder="请输入内容" />,
    },
    {
      name: 'image',
      label: '图片',
      rules: [{ required: false, message: '请选择图片' }],
      render: <UploadImage model="single" callBackString />,
    },
    {
      name: 'video',
      label: '视频',
      rules: [{ required: false, message: '请选择视频' }],
      render: <UploadImage model="single" fileType={["video"]} callBackString />,
    },
    {
      name: 'status',
      label: '是否启用',
      rules: [{ required: false, message: '请输入展示排序' }],
      render: <Switch
        defaultChecked={data?.status === 1}
        checkedChildren='启用'
        unCheckedChildren='隐藏'
      />,
    },

  ];

  return (
    <FormModal
      title="在线学习"
      visible={visible}
      formData={formData}
      initialValues={data}
      onChange={handleSubmit}
    />
  );
}

export default BannderEdit;
